import { list } from 'src/app/common/classes/request-builder';
import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';

export class FertirrigacionListsDefinition {
    public fincas = list();

    public sectores = list();

    public parcelas = list();

    public sistemasRiego: TypeAheadInterface<string> = list();

    public maquinarias: TypeAheadInterface<MaquinariaModel> = list()
    
    public comunidadesRegantes: TypeAheadInterface<ComunidadesRegantesModel> = list();

    public cultivos: TypeAheadInterface<VisitasVariedadMesModel> = list(['...', null]);
}